
























import { Vue, Component, Watch, PropSync, Prop } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import MetaDatatable from '@/models/MetaDatatable';

@Component({})
export default class SearchFilter extends Vue {
    @Prop({ default: 'Rechercher...' }) placeholder!: string;

    searchStr: string | undefined | null = '';
    debouncedOnSearchChange = debounce(this.onSearchChange, 300);

    @PropSync('meta', {
        default: () => {
            return {};
        },
    })
    pMeta!: MetaDatatable;

    onSearchChange() {
        this.pMeta.search = this.searchStr;
    }

    @Watch('searchStr')
    onSearch() {
        this.debouncedOnSearchChange();
    }

    @Watch('pMeta', { deep: true })
    onMeta() {
        if (this.searchStr == '') {
            this.searchStr = this.pMeta.search;
        }
    }
}
